<template>
  <div class="c-material-setting">
    <div class="c-form">
      <ElButton type="primary" @click="addMaterRules">新建规则</ElButton>
    </div>
    <div class="c-m-table" ref="detailtable">
      <Spin size="large" fix v-if="loading" />
      <Viewport v-model="tableHeight">
        <el-table class="common-el-table-styles" ref="table" border stripe :data="tableList" :height="tableHeight">
          <el-table-column
            v-for="(col, id) in columns"
            :key="id"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
            :sortable="col.sortable"
            :sort-orders="['descending', 'ascending', null]"
          >
            <template slot-scope="scope">
              <span v-if="col.key === 'planCount'">{{ `在跑计划数大于 ${scope.row[col.key]} 条` }}</span>
              <div v-else-if="col.key === 'control'">
                <el-button type="text" size="small" class="c-control-margin" @click="editMaterRules(scope.row)">修改</el-button>
                <Poptip confirm transfer title="您确认删除该素材规则吗？" @on-ok="delMaterRules(scope.row)">
                  <el-button type="text" size="small" class="c-control-margin">删除</el-button>
                </Poptip>
              </div>
              <span v-else>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>

        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>

    <set-rule v-model="model" :loading="asyning" :edit-model="editModel" :data="rule" :group-data="groupData" @on-save="asyncOk" />
  </div>
</template>
<script>
import { setLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import mixinTable from './mixin_table'
import columns from '../data/material_setting_column'
import setRule from './components/set-rule'
import { getPtomGroupGames } from '@/api/material.model'
import {
  getMaterLimitRuleList,
  addMaterLimitRules,
  getMaterLimitRuleDetail,
  editMaterLimitRules,
  delMaterLimitRules
} from '@/api/report.model.js'

export default {
  name: 'matersetting',
  mixins: [mixinTable],
  components: { setRule },
  data() {
    return {
      model: null,
      asyning: null,
      loading: null,
      editModel: null,
      pageIndex: 1,
      pageSize: 20,
      tableHeight: 330,
      columns: [],
      tableList: [],
      groupData: [],
      total: 0,
      rule: {}
    }
  },
  methods: {
    getData() {
      const param = { pageId: this.pageIndex, pageSize: this.pageSize }
      this.loading = true
      getMaterLimitRuleList(param)
        .then((data) => {
          this.loading = false
          if (data) {
            const { list, page_info } = data
            this.tableList = list
            this.total = page_info.total_number || 0
          }
        })
        .catch(() => {
          this.loading = false
          this.tableList = []
          this.total = 0
        })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    setLocalPage(size) {
      setLocal('SET_PAGESIZE', size)
    },
    asyncOk(params) {
      const catchErr = () => {
        this.asyning = false
      }
      const callback = (data) => {
        this.asyning = false
        data && (this.model = false)
        data && this.getData()
      }
      this.asyning = true
      if (params.ruleId) editMaterLimitRules(params).then(callback).catch(catchErr)
      else addMaterLimitRules(params).then(callback).catch(catchErr)
    },
    addMaterRules() {
      this.rule = {}
      this.editModel = false
      this.model = true
    },
    editMaterRules(row) {
      if (!row) return
      const { ruleId } = row
      this.$Spin.show()
      getMaterLimitRuleDetail({ ruleId })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            const { ruleId, mediaId, gameGroupId, planCount } = data
            this.rule = { ruleId, mediaId, gameGroupId, planCount }
            this.model = true
            this.editModel = true
          }
        })
        .catch(() => {
          this.$Spin.hide()
        })
    },
    delMaterRules(row) {
      if (!row) return
      const { ruleId } = row
      this.$Spin.show()
      delMaterLimitRules({ ruleId })
        .then((data) => {
          this.$Spin.hide()
          data && this.getData()
        })
        .catch(() => {
          this.$Spin.hide()
        })
    }
  },
  created() {
    this.columns = columns
    getPtomGroupGames().then((groups) => {
      if (isArray(groups)) {
        this.groupData = groups.map((ret) => {
          return {
            id: ret.groupId,
            name: ret.groupName,
            children: ret.gameIds
          }
        })
      }
    })
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-setting {
  position: relative;
  height: 100%;

  .c-form {
    background-color: #fff;
    text-align: right;
    margin-bottom: 5px;
  }

  .c-m-table {
    .c-show-switch {
      height: 32px;
      display: inline-flex;
      align-items: center;
      padding: 0 10px 0 5px;

      span {
        padding: 0 8px;
      }
    }

    .el-table {
      .m-edit-input {
        width: 108px;

        ::v-deep input {
          padding-left: 8px;
        }
      }
    }

    .c-control-margin {
      margin: 0;
      padding: 0 6px;
    }
  }

  .c-table-page {
    padding: 5px;
    text-align: right;
  }
}
</style>
